"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEloise = exports.UndefinedLogic = void 0;
var react_1 = __importStar(require("react"));
var react_router_1 = require("react-router");
var react_router_dom_1 = require("react-router-dom");
var components_1 = require("./components");
require("bootstrap/dist/css/bootstrap.min.css");
var auth_1 = require("react-firebase-hooks/auth");
var _1 = require("./");
var sideModal_1 = __importDefault(require("./components/blocks/sideModal"));
var pages_1 = require("./components/pages");
var footer_1 = __importDefault(require("./components/widgets/footer"));
var functions_1 = require("./functions");
var firebase_1 = require("./functions/firebase");
var siteConfigPlace = {
    api: " ",
    id: "",
    name: "",
    pages: [],
    defaultMode: "Buyer/Seller",
    logo: "",
    inverseLogo: "",
    sideWidget: [],
    eloiseConfig: {
        endPoint: "",
        chatLog: "",
        initMessage: "Hi This is elosie",
    },
    headerTrans: false,
    peopleConfig: [],
};
var UndefinedLogic = /** @class */ (function () {
    function UndefinedLogic() {
        this.apiCall = function () { };
        this.zillowParse = function () { };
        this.hooks = {};
        this.fb = new firebase_1.FB({}, siteConfigPlace);
        this.perms = undefined;
        this.auth = undefined;
        this.other = undefined;
        this.color = {};
        this.generic = {};
        this.api = undefined;
    }
    return UndefinedLogic;
}());
exports.UndefinedLogic = UndefinedLogic;
var ThemeContext = (0, react_1.createContext)({
    fireBaseConfig: {
        config: {
            apiKey: "",
            authDomain: "",
            databaseURL: "",
            projectId: "",
            storageBucket: "",
            messagingSenderId: "",
            appId: "",
        },
        storageDir: "",
    },
    siteConfig: siteConfigPlace,
    theme: {
        colors: [],
        white: "hsla(0, 0%, 100%, 1)",
        font: "",
        fontSize: "3px",
        borderRadius: "3px",
        border: "",
        mode: "light",
    },
    logic: new UndefinedLogic(),
    eloiseContent: [],
    setEloiseContent: function () { }, // Add this line
});
var useEloise = function () { return (0, react_1.useContext)(ThemeContext); };
exports.useEloise = useEloise;
function Eloise(_a) {
    var _this = this;
    var theme = _a.theme, siteConfig = _a.siteConfig, fireBaseConfig = _a.fireBaseConfig;
    (0, react_1.useEffect)(function () {
        var currentPage = window.location.pathname;
        for (var i = localStorage.length - 1; i >= 0; i--) {
            var key = localStorage.key(i);
            if (key) {
                var split = key.split("_");
                if (!key.split("").includes("_")) {
                }
                else {
                    var pageKey = split[0];
                    if (pageKey !== currentPage) {
                        localStorage.removeItem(key);
                    }
                }
            }
        }
    }, []);
    var logic = new functions_1.Logic(fireBaseConfig, siteConfig);
    var _b = (0, react_1.useState)(null), fetchedTheme = _b[0], setFetchedTheme = _b[1];
    // Fetch the theme from the database when the component is mounted
    (0, react_1.useEffect)(function () {
        function fetchTheme() {
            return __awaiter(this, void 0, void 0, function () {
                var themeFromDB;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, logic.fb.docs.getTheme()];
                        case 1:
                            themeFromDB = _a.sent();
                            if (!(themeFromDB && themeFromDB.colors)) return [3 /*break*/, 2];
                            setFetchedTheme(themeFromDB);
                            return [3 /*break*/, 4];
                        case 2:
                            console.log("No Theme in DB Setting to Local Copy");
                            return [4 /*yield*/, logic.fb.docs.setTheme(theme)];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
        fetchTheme();
    }, []);
    var _c = (0, react_1.useState)([]), eloiseContent = _c[0], setEloiseContent = _c[1];
    var _d = (0, auth_1.useAuthState)(logic.fb.auth), user = _d[0], userLoading = _d[1], userError = _d[2];
    var _e = (0, react_1.useState)("white"), mode = _e[0], setMode = _e[1];
    var _f = (0, react_1.useState)(siteConfig.defaultMode), siteMode = _f[0], setSiteMode = _f[1];
    var _g = (0, react_1.useState)([]), remainingPages = _g[0], setRemainingPages = _g[1];
    logic.hooks.useAsyncEffect(function () { return __awaiter(_this, void 0, void 0, function () {
        var locTest, fbTest;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    locTest = localStorage.getItem("siteMode");
                    if (!locTest) return [3 /*break*/, 1];
                    setSiteMode(locTest);
                    return [3 /*break*/, 3];
                case 1:
                    if (!user) return [3 /*break*/, 3];
                    return [4 /*yield*/, logic.fb.docs.getUserDoc("")];
                case 2:
                    fbTest = _a.sent();
                    if (fbTest && fbTest.siteMode) {
                        setSiteMode(fbTest.siteMode);
                        localStorage.setItem("siteMode", fbTest.siteMode);
                    }
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); }, [user]);
    // Helper function to get the first page
    function getFirstPage(pages) {
        return Array.isArray(pages) ? pages[0] : pages(siteMode)[0];
    }
    // Recursive function to generate routes
    function generateRoutes(pages) {
        return pages.map(function (page) {
            var _a;
            // If the page has nested pages, recursively generate routes for them
            if (page.pages) {
                return generateRoutes(page.pages);
            }
            // Otherwise, return a route for the current page
            return (react_1.default.createElement(react_router_1.Route, { key: page.name, path: (_a = page.url) !== null && _a !== void 0 ? _a : "/".concat(page.name), element: react_1.default.createElement(_1.EloiseWidget, { eloiseIntel: __assign({}, page.intel) }, page.component) }));
        });
    }
    (0, react_1.useEffect)(function () {
        var all = Array.isArray(siteConfig.pages)
            ? siteConfig.pages.slice(1)
            : siteConfig.pages(siteMode).slice(1);
        if (!user) {
            all.filter(function (page) { return page.noAuth; });
        }
        setRemainingPages(all);
    }, [user]);
    (0, react_1.useEffect)(function () { }, [eloiseContent]);
    if (siteConfig) {
        return (react_1.default.createElement(ThemeContext.Provider, { value: {
                theme: theme,
                siteConfig: __assign(__assign({}, siteConfig), { pages: typeof siteConfig.pages === "function"
                        ? siteConfig.pages(siteMode).concat([
                            {
                                name: "Error Other",
                                component: react_1.default.createElement(pages_1.Other, null),
                                hidden: true,
                                url: "other",
                            },
                            {
                                name: "Report Bug",
                                component: react_1.default.createElement(pages_1.ReportBug, null),
                                hidden: true,
                                url: "report-bug",
                            },
                        ])
                        : __spreadArray(__spreadArray([], siteConfig.pages, true), [
                            {
                                name: "Error Other",
                                component: react_1.default.createElement(pages_1.Other, null),
                                hidden: true,
                                url: "other",
                            },
                            {
                                name: "Report Bug",
                                component: react_1.default.createElement(pages_1.ReportBug, null),
                                hidden: true,
                                url: "report-bug",
                            },
                        ], false) }),
                fireBaseConfig: fireBaseConfig,
                logic: logic,
                eloiseContent: eloiseContent,
                setEloiseContent: setEloiseContent,
            } },
            react_1.default.createElement("div", { className: "App" },
                react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
                    react_1.default.createElement(components_1.Header, null),
                    react_1.default.createElement(sideModal_1.default, null),
                    react_1.default.createElement(react_router_1.Routes, null,
                        react_1.default.createElement(react_router_1.Route, { path: "/", element: getFirstPage(siteConfig.pages).component }),
                        generateRoutes(remainingPages)),
                    siteConfig.noAuth ? react_1.default.createElement(react_1.default.Fragment, null) : react_1.default.createElement(footer_1.default, null)))));
    }
    else
        return react_1.default.createElement(_1.Loading, null);
}
exports.default = Eloise;
